import {IFileObject, PreSignedURL} from 'models/Common'
import {ChangeEvent} from 'react'
import {toast} from 'react-toastify'
import {uploadFile} from 'utils/api/auth/mediaService'
import {getFileName, getFileType} from 'utils/helper'

const getSignedURL = async (url: string) => {
 if (url) {
  let signedUrl = ''
  //   const payLoad = {
  //    filePath: url,
  //   }
  const pattern = /^((http|https):\/\/)/
  if (pattern.test(url)) {
   signedUrl = url
  } else if (process.env?.ENVIRONMENT === 'production') {
   signedUrl = `https://kheti-cdn.agrevolution.in/${url}`
  } else {
   //    const res: any = await getPreSignedURL(payLoad)
   //    if (res) {
   //     signedUrl = res?.presignedUrl
   //    }
  }
  return signedUrl
 } else {
  return url
 }
}

const fileUploadHandler = async (formData: unknown) => {
 const res = await uploadFile(formData)
 return res
}

const handleFileUpload = async (
 file: File,
 fieldName: string,
 uploadedFileData: IFileObject,
 setLoader: (newState: boolean) => void,
 setUploadedFileData: (newState: IFileObject) => void,
 s3_folder_name?: string
) => {
 let res: PreSignedURL | null = null
 const formData = new FormData()
 let fileName = file.name
 fileName = getFileName(fileName)
 const fileType = getFileType(file.type)
 formData.append('file', file, fileName)
 if (file) {
  if (!['image', 'video', 'document'].includes(fileType)) {
   toast.error(
    `Invalid fileType in request. fileType must image`
   )
  } else {
   setLoader(true)
   formData.append('file_type', fileType)
   formData.append('document_type', fieldName)
   if (s3_folder_name) {
    formData.append('folder_name', s3_folder_name)
   }
   res = await fileUploadHandler(formData)
   if (res) {
    const fileData = {...uploadedFileData}
    fileData[fieldName] = {
     filePath: res.filepath,
     fileName: file.name,
     fileType,
     signedUrl: res.presigned_url,
    }
    setUploadedFileData({...fileData})
   }
   setLoader(false)
  }
 }
 return res
}

const handleFileChange = async (
 e: ChangeEvent<HTMLInputElement>,
 uploadedFileData: IFileObject,
 setLoader: (newState: boolean) => void,
 setUploadedFileData: (newState: IFileObject) => void,
 parentFieldName?: string,
 s3_folder_name?: string,
 bucket?: string
) => {
 e.preventDefault()
 let res: PreSignedURL | null = null
 if (e?.target?.files && e?.target?.files?.length > 0) {
  const file: File = e.target.files[0]
  const filedName = parentFieldName ?? e.target.name
  const formData = new FormData()
  let fileName = file.name
  fileName = getFileName(fileName)
  const fileType = getFileType(file.type)
  formData.append('file', file, fileName)
  if (file) {
   if (!['image', 'video', 'document'].includes(fileType)) {
    toast.error(
     `Invalid fileType in request. fileType must image`
    )
   } else {
    setLoader(true)
    formData.append('file_type', fileType)
    formData.append('document_type', filedName)
    if (s3_folder_name) {
     formData.append('folder_name', s3_folder_name)
    }
    if (bucket) {
     formData.append('bucket', bucket)
    }
    res = await fileUploadHandler(formData)
    if (res) {
     const fileData = {...uploadedFileData}
     fileData[e.target.name] = {
      filePath: res.filepath,
      fileName: file.name,
      fileType,
      signedUrl: res.presigned_url,
      fileSize: file.size,
     }
     setUploadedFileData({...fileData})
    }
    setLoader(false)
   }
  }
 }
 return res
}

type HandleFileDeleteOptions = {
 isMultiple?: boolean
 parentFieldId?: string
 getValues?: (name: string) => unknown
 onMultipleDelete?: (parentFieldId: string) => void
}

const handleFileDelete = (
 fieldName: string,
 setUploadedFileData: (
  state: IFileObject | ((prev: IFileObject) => IFileObject)
 ) => void,
 setValue: (name: string, value: string | string[]) => void,
 options?: HandleFileDeleteOptions
) => {
 setUploadedFileData((prev) => {
  const fileData = {...prev}
  delete fileData[fieldName]
  return fileData
 })

 setValue(fieldName, '')

 if (
  options?.isMultiple &&
  options?.parentFieldId &&
  options?.getValues
 ) {
  const parentValue = options.getValues(
   options.parentFieldId
  )
  if (Array.isArray(parentValue)) {
   const fieldArr = fieldName.split('.')
   const index = parseInt(fieldArr[1], 10)
   if (!Number.isNaN(index)) {
    const newArray = parentValue.filter(
     (_: unknown, i: number) => i !== index
    )
    setValue(options.parentFieldId, newArray)
   }
  }
  options.onMultipleDelete?.(options.parentFieldId)
 }
}

export {
 getSignedURL,
 fileUploadHandler,
 handleFileUpload,
 handleFileChange,
 handleFileDelete,
}
